import { useDeliveryEstimate } from '../../api/addresses'
import styles from './DeliveryEstimateDisplay.module.css'

interface DeliveryEstimateDisplayProps {
  lat?: number
  lng?: number
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function DeliveryEstimateDisplay({ lat, lng }: DeliveryEstimateDisplayProps) {
  const hasCoords = lat !== undefined && lng !== undefined
  const { data: estimate, isLoading, error } = useDeliveryEstimate(lat ?? 0, lng ?? 0, hasCoords)

  if (!hasCoords) {
    return null
  }

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Checking delivery availability...</div>
      </div>
    )
  }

  if (error || !estimate) {
    return (
      <div className={styles.container}>
        <div className={styles.error}>Unable to check delivery</div>
      </div>
    )
  }

  if (!estimate.isDeliverable) {
    return (
      <div className={`${styles.container} ${styles.notAvailable}`}>
        <div className={styles.icon}>NO</div>
        <div className={styles.content}>
          <div className={styles.title}>DELIVERY NOT AVAILABLE</div>
          <div className={styles.subtitle}>This location is outside our delivery area</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.container} ${styles.available}`}>
      <div className={styles.icon}>OK</div>
      <div className={styles.content}>
        <div className={styles.title}>DELIVERY AVAILABLE</div>
        <div className={styles.details}>
          <span className={styles.fee}>{formatCurrency(estimate.fee)}</span>
          <span className={styles.separator}>•</span>
          <span className={styles.time}>~{estimate.estimatedMinutes} min</span>
        </div>
        {estimate.zone && (
          <div className={styles.zone}>{estimate.zone.name}</div>
        )}
      </div>
    </div>
  )
}
